<template>
	<div ref="console" class="draggable" @mousedown="dragMouseDown" @touchstart="dragMouseDown">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'draggable',
	props: {
		initialPosition: {
			type: Object,
			default: () => ({
				top: null,
				left: null,
				right: null,
				bottom: null,
				unit: 'px'
			})
		}
	},
	data() {
		return {
			pos1: 0,
			pos2: 0,
			pos3: 0,
			pos4: 0,
			startPosX: 0,
			startPosY: 0,
			isDragging: false,
			dragThreshold: 5 // Minimum movement in pixels to consider it a drag
		};
	},
	mounted() {
		const { top, left, right, bottom, unit } = this.initialPosition;
		const consoleElement = this.$refs.console;

		if (top !== null) consoleElement.style.top = top + unit;
		if (left !== null) consoleElement.style.left = left + unit;
		if (right !== null) consoleElement.style.right = right + unit;
		if (bottom !== null) consoleElement.style.bottom = bottom + unit;
	},
	methods: {
		dragMouseDown(e) {
			e.preventDefault();
			this.isDragging = false;
			if (e.type === 'touchstart') {
				this.pos3 = e.touches[0].clientX;
				this.pos4 = e.touches[0].clientY;
				this.startPosX = this.pos3;
				this.startPosY = this.pos4;
				document.ontouchend = this.closeDragElement;
				document.ontouchmove = this.elementDrag;
			} else {
				this.pos3 = e.clientX;
				this.pos4 = e.clientY;
				this.startPosX = this.pos3;
				this.startPosY = this.pos4;
				document.onmouseup = this.closeDragElement;
				document.onmousemove = this.elementDrag;
			}
		},
		elementDrag(e) {
			e.preventDefault();
			if (e.type === 'touchmove') {
				this.pos1 = this.pos3 - e.touches[0].clientX;
				this.pos2 = this.pos4 - e.touches[0].clientY;
				this.pos3 = e.touches[0].clientX;
				this.pos4 = e.touches[0].clientY;
			} else {
				this.pos1 = this.pos3 - e.clientX;
				this.pos2 = this.pos4 - e.clientY;
				this.pos3 = e.clientX;
				this.pos4 = e.clientY;
			}

			const consoleElement = this.$refs.console;
			let newTop = consoleElement.offsetTop - this.pos2;
			let newLeft = consoleElement.offsetLeft - this.pos1;

			// Ensure the element stays within the viewport
			if (newTop < 0) newTop = 0;
			if (newLeft < 0) newLeft = 0;
			if (newTop + consoleElement.clientHeight > window.innerHeight) {
				newTop = window.innerHeight - consoleElement.clientHeight;
			}
			if (newLeft + consoleElement.clientWidth > window.innerWidth) {
				newLeft = window.innerWidth - consoleElement.clientWidth;
			}

			consoleElement.style.top = newTop + 'px';
			consoleElement.style.left = newLeft + 'px';
			consoleElement.style.right = 'auto';
			consoleElement.style.bottom = 'auto';

			// Check if the movement exceeds the threshold to consider it a drag
			if (
				Math.abs(this.startPosX - this.pos3) > this.dragThreshold ||
				Math.abs(this.startPosY - this.pos4) > this.dragThreshold
			) {
				this.isDragging = true;
			}
		},
		closeDragElement(e) {
			document.onmouseup = null;
			document.onmousemove = null;
			document.ontouchend = null;
			document.ontouchmove = null;

			// Emit click event if it was not a drag
			if (!this.isDragging) {
				this.$emit('click', e);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../style/common';
.draggable {
	position: fixed;
	width: max-content;
	z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/draggable.vue